import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import {
    EmojiInput,
    type EmojiInputProps,
    type EmojiInputRef,
} from '../EmojiInput';

export type RoundedEmojiInputProps = EmojiInputProps;
export type RoundedEmojiInputRef = EmojiInputRef;

const STYLES = {
    mobile: {
        fontSize: '2rem',
        height: '5rem',
        marginRight: 0,
        padding: '1.25rem 5rem 1.25rem 2.188rem',
        focused: {
            marginRight: '6rem',
        },
    },
    desktop: {
        fontSize: '1.375rem',
        height: '4rem',
        marginRight: 0,
        padding: '0.625rem 4.5rem 0.625rem 1.5rem',
        focused: {
            marginRight: '4.25rem',
        },
    },
};

const styles = STYLES[isMobile ? 'mobile' : 'desktop'];

export const RoundedEmojiInput = styled(EmojiInput)<{
    focused?: boolean;
    disabled?: boolean;
}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: black;
    font-family: Signika-Medium;
    font-size: ${styles.fontSize};
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    width: 100%;
    height: ${styles.height};
    border-width: 0;
    border-radius: 2.5rem;

    &:focus {
        outline: none;
    }

    ${({ focused, theme, disabled }) => `
        margin-right: ${
            focused ? styles.focused.marginRight : styles.marginRight
        };
        padding: ${styles.padding};
        cursor: ${disabled ? 'not-allowed' : 'auto'};
        opacity: ${disabled ? 0.5 : 1};
        background-color: ${theme.color};
    `};
`;
